export default "__VITE_ASSET__D5fBu58y__"